export default __webpack_public_path__ + "static/media/address-location.e079f691.png";